import type ReadingPaneOptionState from './schema/ReadingPaneOptionState';
import { createStore } from 'owa-satcheljs';

const defaultExport: () => ReadingPaneOptionState = createStore<ReadingPaneOptionState>(
    'readingPaneOption',
    {
        readingPanePosition: null,
        nextSelection: null,
        loadMessageOnLogOn: null,
    }
);
export default defaultExport;
